import * as components from './components'

export default [
  {
    path: '/club/create',
    component: components.ClubCreate,
    name: 'clubCreate',
    props: true
  },
  {
    path: '/club/:uuid/home',
    component: components.ClubDetail,
    name: 'clubDetail',
    props: true
  },
  {
    path: '/club/:uuid/edit',
    component: components.EditClub,
    name: 'editClub',
    props: true
  },
  {
    path: '/club/upload',
    component: components.ClubUpload,
    name: 'clubUpload',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/club/routes.js